import React from "react";
import { Route, Switch } from "react-router-dom";

import DasReport from "./containers/dasReport";
import DasnReport from "./containers/dasnReport";

const routes = () => {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/fiscal/das" component={DasReport} />
				<Route exact path="/fiscal/dasn" component={DasnReport} />
			</Switch>
		</React.Fragment>
	);
};

export default routes;
